import config from '@/config'
import { ROUTE_NAMES } from '@/constant/routes'

// The embedded Home (aha-onboarding) reads this snapshot when it mounts to pick
// its variant, and shows a skeleton of a guessed variant until it lands (up to
// 3 s). Firing the same request as navigation to Home starts runs it in
// parallel with presenter's own boot, so the iframe finds it in the HTTP cache
// (max-age=60). Same idea as onboarding-warmup.js's prefetchRoutingConfig
// (AHA-47537), for the 'home' surface.
// MUST stay byte-identical to aha-onboarding src/home-screen/shell/homeRouting.ts
// (`${baseUrl}${ROUTING_CONFIG_PATH}`, with baseUrl = config.baseUrl from
// EmbeddedHomeScreenIframe.vue), or the two requests are different cache entries.
const HOME_ROUTING_CONFIG_PATH = '/api/onboarding/routing-config?surface=home'

/**
 * Router guard helper: prefetch the Home routing config when `to` is Home.
 * Plain GET with no init (the endpoint is public and auth-free), for the same
 * cache-entry reason as above. Best-effort: a missed prefetch only means the
 * Home app fetches it itself, so this never throws.
 */
export function prefetchHomeRoutingConfig(to) {
  if (to?.name !== ROUTE_NAMES.HOME) return
  try {
    fetch(`${config.baseUrl || ''}${HOME_ROUTING_CONFIG_PATH}`).catch(() => {})
  } catch (err) {
    // No usable fetch here (older embedded webviews). The Home app still fetches it.
  }
}
